import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserThunk } from '../../features/user/thunk/user.thunk';
import { ROUTE_PROFILE } from '../constants';
import { unregisterPushToken, ensureAnonymousAuth, registerPushToken } from '../anonymousAuth';
import { useLocaleNavigate } from './useLocaleNavigate';

export const useMe = () => {
  const navigate = useLocaleNavigate();
  const dispatch = useDispatch();

  const token = localStorage.getItem('userAuthToken');
  const { result, isLoading } = useSelector((state) => state.me);

  const logout = async () => {
    await unregisterPushToken();
    localStorage.removeItem('userAuthToken');
    await ensureAnonymousAuth();
    await registerPushToken();
    navigate(ROUTE_PROFILE);
    window.location.reload();
  };

  useEffect(() => {
    if (token) dispatch(getUserThunk({}));
  }, [dispatch, token]);

  return { isLoading, logout, result, token };
};
